import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UtilisateurSearch from './UtilisateurSearch';
import { fetchSuggestionsUtilisateur, clearSuggestionsUtilisateur, clearUtilisateurValue, setUtilisateurValue } from 'store/utilisateur/utilisateursActions';

class UtilisateurSearchContainer extends React.Component {

    componentDidMount() {
        // On ne resette plus la valeur, si on vient du tableau de bord on peut l'avoir modifier.
        //this.props.clearUtilisateurValue();
    }

    componentWillUnmount() {
        this.props.clearUtilisateurValue();
        this.props.clearSuggestionsUtilisateur();
    }

    handleSearch = (searchValue) => {
        this.props.fetchSuggestionsUtilisateur(searchValue);
    }

    handleClear = () => {
        this.props.clearSuggestionsUtilisateur();
    }

    handleChange = (value) => {
        const { selectedId } = this.props;
        this.props.setUtilisateurValue(value, selectedId);
    }

    handleSuggestionSelected = (id, value, codePO, nom, prenom) => {
        this.props.setUtilisateurValue(value, id);
        this.props.onChange(id, codePO, nom, prenom);
    }

    render() {
        const { utilisateurs, value, selectedId, isRequired, error, label, autoFocus, size } = this.props;

        return (
            <UtilisateurSearch
                utilisateurs={utilisateurs}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                onClear={this.handleClear}
                error={error}
                isRequired={isRequired}
                onSuggestionSelected={this.handleSuggestionSelected}
                value={value}
                selectedId={selectedId}
                label={label}
                autoFocus={autoFocus}
                size={size}
            />);
    }
}

const mapStateToProps = (state, ownProps) => ({
    utilisateurs: state.utilisateur.utilisateurs[ownProps.namespace].suggestions.items,
    value: state.utilisateur.utilisateurs[ownProps.namespace].suggestions.value,
    selectedId: state.utilisateur.utilisateurs[ownProps.namespace].suggestions.selectedId
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchSuggestionsUtilisateur: (searchValue) => dispatch(fetchSuggestionsUtilisateur(ownProps.namespace, searchValue)),
    clearSuggestionsUtilisateur: () => dispatch(clearSuggestionsUtilisateur(ownProps.namespace)),
    clearUtilisateurValue: () => dispatch(clearUtilisateurValue(ownProps.namespace)),
    setUtilisateurValue: (value, selectedId) => dispatch(setUtilisateurValue(ownProps.namespace, value, selectedId))
});

UtilisateurSearchContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    autoFocus: PropTypes.bool,
    error: PropTypes.object,
    label: PropTypes.string,
    size: PropTypes.string,
};


UtilisateurSearchContainer.defaultProps = {
    autoFocus: false
};

export default connect(mapStateToProps, mapDispatchToProps)(UtilisateurSearchContainer);